
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductType } from "../../../all-types";
import { getProductsList } from "../../../services";

const STATUS = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  EMPTY: "EMPTY",
};

const initialState: {
  data: ProductType[];
  filteredProducts?: ProductType[];
  status: string;
  error: string;
} = {
  data: [],
  filteredProducts: [],
  status: STATUS.EMPTY,
  error: "",
};

export const ProductsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<ProductType[]>) => {
      state.data = action.payload;
      state.filteredProducts = action.payload; // Initialize filteredProducts with all products
    },
    setFilteredProducts: (state, action: PayloadAction<ProductType[]>) => {
      state.filteredProducts = action.payload; // Initialize filteredProducts with all products
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductsList.pending, (state) => {
        state.status = STATUS.LOADING;
      })
      .addCase(getProductsList.fulfilled, (state, action) => {
        state.status = STATUS.SUCCESS;
        state.data = action.payload;
        state.filteredProducts = action.payload; // Initialize filteredProducts with all products
      })
      .addCase(getProductsList.rejected, (state, action) => {
        state.status = STATUS.FAILED;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { setProducts, setFilteredProducts } = ProductsSlice.actions;
